import { OutlinedInput } from "@mui/material";
import { forwardRef, useMemo } from "react";
import { MetadataInputProps } from "../metadata-input-index";

export type LocalizedTitleMetadataInfos = {
  cultureId: number;
  language: string;
  value: string;
  epNb?: number | null;
};

type LocalizedTitleMetadataInfosIndexed = {
  index: number;
  data: LocalizedTitleMetadataInfos;
};

const MetadataInputTitlesMultiLocalized = forwardRef<any, MetadataInputProps>((props, ref) => {
  const { onChange, data, value, cultureId, epNb } = props;

  const localized = useMemo((): LocalizedTitleMetadataInfosIndexed => {
    return {
      index: (value as LocalizedTitleMetadataInfos[]).findIndex((x) => x.cultureId === cultureId && x.epNb === epNb),
      data: (value as LocalizedTitleMetadataInfos[]).find((x) => x.cultureId === cultureId && x.epNb === epNb)!,
    };
  }, [value, cultureId, epNb]);

  return (
    <OutlinedInput
      id={data.tagName!}
      // value management
      value={localized?.data?.value || ""}
      onChange={(e) =>
        onChange(
          { ...localized.data, value: e.currentTarget.value, epNb: epNb },
          data.id,
          localized.index >= 0 ? localized.index : value.length
        )
      }
      sx={{ width: "100%" }}
    />
  );
});

export default MetadataInputTitlesMultiLocalized;
